import { ConferenceRegistrationPage } from '@/components/admin/events/ConferenceRegistrationPage/ConferenceRegistrationPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(ConferenceRegistrationPage, {
  requiresEvery: [
    RouteRestrictions.ADMIN_ROLE,
    RouteRestrictions.FEATURE_FLAG_CONFERENCES,
  ],
});
